import { Control, FieldValues, Path } from "react-hook-form";
import { FormControl, FormField, FormItem, FormMessage } from "./Form";
import { Checkbox, CheckboxProps } from "../Checkbox";
import { Label } from "@radix-ui/react-label";
import { cn } from "../../../utils";
import {
  checkboxClassName,
  checkboxContainerClassName,
} from "../../../styles/input";
import { CheckedState } from "@radix-ui/react-checkbox";
import { JSX } from "react";

export type FormCheckboxProps<TForm extends FieldValues> = {
  control: Control<TForm>;
  name: Path<TForm>;
  className?: string;
  labelContent: JSX.Element | string;
  labelClassName?: string;
  hasMessage?: boolean;
  checkboxClassNames?: string;
  onCheckedAfterChange?: (value: CheckedState) => void;
} & CheckboxProps;

export function FormCheckbox<TForm extends FieldValues>({
  control,
  name,
  className,
  labelContent,
  labelClassName = "",
  hasMessage = false,
  onCheckedChange,
  onCheckedAfterChange,
  checkboxClassNames,
  ...props
}: FormCheckboxProps<TForm>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className="w-full flex-1">
          <div className={cn(checkboxContainerClassName, className)}>
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={(value) => {
                  if (onCheckedChange) onCheckedChange(value);
                  field.onChange(value);
                  if (onCheckedAfterChange) onCheckedAfterChange(value);
                }}
                id={(name as string).replaceAll(".", "-")}
                className={cn(
                  checkboxClassName,
                  {
                    "border-destructive": fieldState.error,
                  },
                  checkboxClassNames
                )}
                {...props}
              />
            </FormControl>

            {!labelContent ? null : (
              <Label
                className={labelClassName}
                htmlFor={(name as string).replaceAll(".", "-")}
              >
                {labelContent}
              </Label>
            )}
          </div>

          {hasMessage ? <FormMessage className="mt-2" /> : null}
        </FormItem>
      )}
    />
  );
}

export default FormCheckbox;
